<template>
  <div class="personal-data-agreement">
    <Checkbox class="personal-data-agreement__checkbox" :value="value" :error="error" @input="onInput">
      <template #label>
        {{ $root.staticText.forms.agree }}
        <a class="personal-data-agreement__link" href="/user-agreement" target="_blank" @click="$emit('link-click', $event)">
          {{ $root.staticText.forms.personalData }}
        </a>
      </template>
    </Checkbox>
  </div>
</template>

<script>
import Checkbox from '@shared/ui/public/forms/fields/Checkbox.vue'

export default {
  name: 'PersonalDataAgreement',
  emits: ['input', 'link-click'],
  components: { Checkbox },
  props: {
    value: {
      type: [String, Number, Boolean],
      required: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.personal-data-agreement
  &__link
    color: var(--form-link-color, rgba(255, 255, 255, .7))
    transition: color .2s

    &:hover
      color: var(--form-link-hover, $white)

  &__checkbox
    font-size: 16px
    width: fit-content
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/PersonalDataAgreement.vue